import { useMemo } from "react";
import MassFlow from "../../components/massFlow";
import { MassFlowConfig } from "../../components/massFlow/types";
import { cdnMassColumns } from "../columns";
import { validateCdn } from "../validation";
import { cdnsFromCsv, downloadCsvTemplate } from "./csv";
import { Cdn, CDN_FIELDS, emptyCdn } from "../types";

export interface MassCdnsProps {
  cdns: Cdn[];
  search: string;
  onSearchChange: (value: string) => void;
  onBack: () => void;
  onSaved: () => Promise<void> | void;
}

export default function MassCdns(props: MassCdnsProps) {
  const { cdns, search, onSearchChange, onBack, onSaved } = props;

  const config = useMemo<MassFlowConfig>(
    () => ({
      tableId: "cdnsMassFlow",
      endpoint: "/easyFlow2.0/cdn",
      entity: {
        singular: "CDN",
        plural: "CDNs",
        gender: "m",
      },
      searchPlaceholder: "Pesquisar CDNs",
      fields: CDN_FIELDS,
      emptyValues: emptyCdn,
      columns: cdnMassColumns,
      validate: validateCdn,
      csv: {
        onDownloadTemplate: downloadCsvTemplate,
        parse: cdnsFromCsv,
      },
    }),
    [],
  );

  return (
    <MassFlow
      config={config}
      records={cdns}
      search={search}
      onSearchChange={onSearchChange}
      onBack={onBack}
      onSaved={onSaved}
    />
  );
}
